import React from 'react';
import { TableCell, TableSortLabel } from '@mui/material';

/// Cabeçalho clicável para ordenação client-side (paridade visual MUI).
export default function SortableTh({
  id,
  label,
  orderBy,
  order = 'asc',
  onSort,
  align = 'left',
  sx,
  ...rest
}) {
  const active = orderBy === id;
  return (
    <TableCell
      align={align}
      sortDirection={active ? order : false}
      sx={sx}
      {...rest}
    >
      <TableSortLabel
        active={active}
        direction={active ? order : 'asc'}
        onClick={() => onSort?.(id)}
        hideSortIcon={false}
      >
        {label}
      </TableSortLabel>
    </TableCell>
  );
}
